<div class="add-comment-page">
    <header class="pt-5 text-center text-secondary container">
        <h1 class="pb-1 fs-3 fw-normal">
            {{'choose_mood.title' | translate}}
        </h1>
        <p class="col-md-4 mx-auto">{{'choose_mood.description' | translate}}</p>
        <hr class="w-25 mx-auto pt-2">
    </header>

    
    <div id="container" class="container">
        <div class="row">
            <form class="form mt-4 col-md-9 mx-auto">

                <div class="mb-5 pb-0">

                    <add-mood [mood]="mood"
                              [previousComment]=""
                    (onMoodUpdated)="onMoodUpdated($event)"></add-mood>

                    <div class="text-end">
                        <button class="btn btn-primary py-2 px-3" (click)="next()" [disabled]="!mood.id">
                            <span>
                                {{ 'add_comment_next.next' | translate }} <i class="far fa-chevron-right ps-2"></i>
                            </span>
                        </button>
                    </div>

                    <div class="row mt-0 mx-auto mb-3 row gx-5 informations">
                        <div class="media col-md-6 d-flex">
                            <i class="far fa-mask fa-4x" aria-hidden="true"></i>
                            <div class="media-body px-3">
                                <h4 class="media-heading">{{'add_comment_anonymous' | translate}}</h4>
                                <p>{{'add_comment_information_anonymous' | translate}}</p>
                            </div>
                        </div>
                        <div class="media col-md-6 d-flex">
                            <i class="far fa-comment fa-4x" aria-hidden="true"></i>
                            <div class="media-body px-3">
                                <h4 class="media-heading">{{'add_comment_civil' | translate}}</h4>
                                <p>
                                    {{'add_comment_informations_disclaimer' | translate}}
                                    <a href="/{{mood.teamId}}/codeofconduct" target="_blank">{{'add_mood_box.code_of_conduct' | translate}}</a>
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </form>
        </div>
    </div>
</div>